import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { useEarningsQuantities } from "../useEarningsQuantities";
import { requestPayAllEarnings } from "./payAllEarnings.request";

export const usePayAllEarnings = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  const refetchEarnings = useRefetchQuery(["earnings"]);
  const refetchMobileMoneyBalance = useRefetchQuery(["mobile-money-balance"]);
  const { refetch: refetchEarningsQuantities } = useEarningsQuantities({
    enabled: false
  });

  return useMutation({
    mutationFn: requestPayAllEarnings,
    ...options,
    onSuccess: (data, variables, context) => {
      refetchEarningsQuantities();
      refetchEarnings();
      refetchMobileMoneyBalance();
      options?.onSuccess?.(data, variables, context);
    }
  });
};

export default usePayAllEarnings;
